<template>
  <div class="phone-change">
    <template v-if="!hideSubmenuItem">
    <base-heading :underline="false">
      {{ $t('userAccount.changePhone.title') }}
    </base-heading>
    <p class="list-label"> {{ $t('userAccount.changePhone.customerIdLabel') }}</p>
    <div v-if="customerIdsList.length > 0">
      <div class="phone-cards-wrapper">
        <div v-for="(card, index) in customerIdsList" :key="'card' + index">
          <div class="card" @click="pickCustomerId(index, card.formattedContactPhone, card.subscriptionInfo.customerId)"
               :class="isActive === index ? 'active' : null">
            <p class="title">{{ card.subscriptionInfo.firstName }}&nbsp;{{ card.subscriptionInfo.lastName }}</p>
            <p class="subtitle">{{ card.subscriptionInfo.description }}</p></div>
        </div>
      </div>
      <div class="change-phone-form">
        <validation-observer ref="changePhone"
                             tag="form"
                             @submit.prevent="submitChangePhone">
          <div class="form-fields">
            <v-popover trigger="hover" placement="left" popover-class="addon-popover">
              <img class="info-icon"
                    src="/assets/images/tooltip-info-16.png"
                    alt="info-icon">
              <template slot="popover">
                <div class="phone-hint">
                  <p class="phone-hint-format">{{ $t('userAccount.changePhone.enterInFormat') }}</p>
                </div>
              </template>
            </v-popover>
            <base-v-input v-model.trim="phoneInput"
                          id="changePhone"
                          ref="phone"
                          name="phone"
                          variant="white"
                          :placeholder="this.oldPhone"
                          :submitted="changePhoneSubmitted"
                          :label="$t('userAccount.changePhone.phoneLabel')"
                          rules="required|internationalPhoneNumber"
                          vid="phoneNumber"
            >
            </base-v-input>
            <base-button :disabled="!changePhoneFormFilled || buttonDisabled" :loading="dataLoading" class="save-btn"
                         type="submit">
              {{ $t('userAccount.emailChange.saveChangesButton') }}
            </base-button>
          </div>
        </validation-observer>
      </div>
    </div>
    <loader-with-message v-else
                         :key="'loader'"
                         :has-error="dataFetchError"
                         @retry="getCustomerIds"/>
    </template>
    <template v-else>
      <div class="mobile-users-message">
      <img src="/assets/images/no-results.svg" width="112" height="112" alt=""/>
      <h3 class="title">{{ $t('userAccount.changePhone.mobileUsersTitle') }}</h3>
      <p class="description">{{ $t('userAccount.changePhone.mobileUsersMessage') }}</p>
      </div>
    </template>
  </div>
</template>

<script>
import errorMessageHandler from '@/mixins/errorMessageHandler'
import LoaderWithMessage from '@/components/common/loader-with-message'

export default {
  name: 'phone-change',
  data () {
    return {
      phoneInput: '',
      buttonDisabled: false,
      dataLoading: false,
      changePhoneSubmitted: false,
      oldPhone: '',
      customerIdsList: [],
      customerInfo: '',
      customerId: '',
      isActive: null,
      dataFetchError: false,
      serviceType: {},
      hideSubmenuItem: false
    }
  },
  components: { LoaderWithMessage },
  mixins: [errorMessageHandler],
  computed: {
    changePhoneFormFilled () {
      return !!this.phoneInput
    }
  },
  methods: {
    fetchTypeService () {
      this.$apiRequest.get('user/info')
        .then(response => {
          this.serviceType = response.data.serviceTypes || {}
          if (this.serviceType.indexOf('FIXED_TELEPHONY', 'BOX', 'INTERNET') < 0) {
            this.hideSubmenuItem = true
          }
          console.log(this.hideSubmenuItem)
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
    },
    resetData () {
      this.phoneInput = ''
      this.changePhoneSubmitted = false
      this.$refs.changePhone.reset()
    },
    pickCustomerId (i, formattedContactPhone, customerId) {
      this.isActive = i
      this.oldPhone = formattedContactPhone
      this.customerId = customerId
    },
    getCustomerIds () {
      this.dataFetchError = false
      this.$apiRequest.get('user/fixed')
        .then(response => {
          this.customerIdsList = response.data.mtmCustomers || []

          if (this.customerIdsList.length) {
            const index = this.isActive !== null ? this.isActive : 0
            this.pickCustomerId(index, this.customerIdsList[index].formattedContactPhone, this.customerIdsList[index].subscriptionInfo.customerId)
          }
        })
        .catch(() => {
          this.dataFetchError = true
        })
    },
    async submitChangePhone () {
      this.changePhoneSubmitted = true
      const valid = await this.$refs.changePhone.validate()

      if (valid) {
        this.dataLoading = true
        this.$apiRequest.put('/user/contactphone', { customerId: this.customerId, phoneNumber: this.phoneInput })
          .then((response) => {
            if (response.status === 200) {
              this.toast('success', {
                title: this.$t('toastMessages.successToastTitle'),
                message: this.$t('userAccount.changePhone.toastSuccessMessage', { phoneInput: this.phoneInput })
              })
              this.resetData()
              this.getCustomerIds()
            }
          })
          .catch(e => {
            this.handleErrorMessage(e.response.data)
            this.dataFetchError = true
          })
          .finally(() => {
            this.dataLoading = false
            this.buttonDisabled = false
          })
      } else {
        this.dataLoading = false
      }
    }
  },
  mounted () {
    this.getCustomerIds()
    this.fetchTypeService()
  }
}
</script>

<style lang="scss" scoped>
.phone-change {
  padding-top: 2rem;

  .change-phone-form {
    width: 100%;

    @media (map_get($breakpoints, sm)) {
      width: 36rem;
    }

    .save-btn {
      width: 100%;
      margin-top: 1rem;

      @media (map_get($breakpoints, sm)) {
        width: auto;
      }
    }
  }

  .list-label {
    font-size: 1.2rem;
    color: $dark-grey;
    margin-bottom: 8px;
  }

  .phone-cards-wrapper {
    display: flex;
    margin-bottom: 3.2rem;
    flex-direction: column;

    @media (map_get($breakpoints, sm)) {
      flex-direction: row;
    }

    .card {
      width: 100%;
      background: $white;
      border-radius: 5px;
      margin-right: 2.4rem;
      padding: 8px 16px;
      cursor: pointer;
      border: 1px solid $white;
      transition: border 0.5s ease-out;
      margin-bottom: 2.4rem;

      @media (map_get($breakpoints, sm)) {
        width: 18rem;
      }

      &.active {
        border: 1px solid $primary;

        .title {
          color: $primary;
        }
      }

      .title {
        font-weight: 700;
        color: $light-black;
      }

      .subtitle {
        font-size: 12px;
        color: $dark-grey;
        line-height: 1.5;
      }
    }
  }
  .mobile-users-message {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    color: $dark;
    padding-top: 4rem;
    text-align: center;

    @media (map_get($breakpoints, sm)) {
      padding-top: 14rem;
    }

    img {
      display: inline-block;
      width: 112px;
      height: auto;
      margin: 0 auto 2.4rem;
    }

    .title {
      font-size: 3.2rem;
      font-weight: normal;
      margin-bottom: 4rem;
    }

    .description {
      font-size: 1.6rem;
    }
  }

  .v-popover {
    position: relative;
    z-index: 99;
  }
}

.phone-hint {
  padding: 1rem 1.6rem;
  max-width: 300px;
}

</style>
